function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgManualTax = function SvgManualTax(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-9",
    transform: "translate(-262.000000, -860.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(180.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 820.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-56",
    x: 2,
    y: 0,
    style: {
      fill: "none"
    },
    width: 20,
    height: 20
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    style: {
      fill: "#B1C3CC"
    },
    d: "M9,7H7v2h2v6h2V9h2V7h-2H9z M12,0H4C2.9,0,2,0.9,2,2v16c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V6L12,0z  M16,18H4V2h7l5,5V18z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgManualTax, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/manual_tax.2d56542f.svg";
export { ForwardRef as ReactComponent };